export var goToSearchPage = function goToSearchPage() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    searchParams = _ref.searchParams;
  var url = "/search".concat(searchParams ? "?".concat(searchParams) : '');
  window.location.assign(url);
};